/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { type QueryFunctionContext } from '@tanstack/react-query';

import { recordSnapshotLastSeq } from '../../nats/snapshot-seq-store.js';

import { fetchWithHttpTelemetry } from '../../transport/http-request.js';

import { throwHttpError } from '../../core/http-error.js';

import type { GetWatchlistRow } from '../openapi-types.gen.js';

import type { EntityKeyFactory, HookSpec } from '../../types/HookSpec.js';
import type { JsonSerialisableArgs } from '../../types/JsonSerialisableArgs.js';


// ─── useGetWatchlist ────────────────────────────────────────────────────────────

export interface useGetWatchlistArgs { readonly kind: string; readonly fields?: readonly ('pubkeys')[]; }


async function _useGetWatchlistQueryFn(
  args: useGetWatchlistArgs,
  ctx: QueryFunctionContext,
): Promise<GetWatchlistRow | null> {
  if (args.kind === undefined || args.kind === null || args.kind === '') return null;
  const url = `/v1/watchlist/${args.kind}`;
  const params = new URLSearchParams();
  // `args.fields` is a client-side projection; the API always returns the full DTO.
  const sep = url.includes('?') ? '&' : '?';
  const full = params.size > 0 ? `${url}${sep}${params.toString()}` : url;
  const res = await fetchWithHttpTelemetry({
    operationName: 'useGetWatchlist',
    routeTemplate: '/v1/watchlist/{kind}',
    requestKind: 'query',
    method: 'GET',
    url: full,
    signal: ctx.signal,
    init: {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
      ...(ctx.signal !== undefined ? { signal: ctx.signal } : {}),
    },
  });
  // A signed-out / session-expired caller gets 401 — that is a normal
  // "anonymous" state. A 403 retains its canonical error envelope.
  if (res.status === 401) return null;
  if (!res.ok) await throwHttpError('GET', full, res);
  const json = (await res.json()) as unknown;
  recordSnapshotLastSeq(ctx.queryKey, json);
  const data =
    json !== null && typeof json === 'object' && 'data' in json
      ? (json as { data: unknown }).data
      : json;
  return data as GetWatchlistRow;
}


const _useGetWatchlistFactory = Object.assign(
  (args: useGetWatchlistArgs) => ({
    queryKey: ['watchlist', 'detail', args.kind] as readonly unknown[],
    queryFn: (ctx: QueryFunctionContext) => _useGetWatchlistQueryFn(args, ctx),
    staleTime: 2000,
    // structuralSharing kept ON (TanStack default). The codegen-emitted
    // applyEvent already preserves row references for unchanged rows;
    // structural sharing on top lets per-card `select` selectors
    // short-circuit when their row hasn't changed, avoiding cascade
    // re-renders of every list child on each patch.
    meta: {
      realtime: false,
      pollingManaged: true,
      specName: 'useGetWatchlist',
      viewerSensitive: true,
      persist: false,
    } as const,
  }),
  {
    __brand: 'EntityKeyFactory' as const,
    prefix: (id: string) => ['watchlist', 'detail', id] as readonly unknown[],
  },
) as unknown as EntityKeyFactory<useGetWatchlistArgs, GetWatchlistRow>;


export const useGetWatchlistSpec = {
  __brand: 'HookSpec' as const,
  path: '/v1/watchlist/{kind}',
  method: 'GET' as const,
  kind: 'detail' as const,
  mounting: { kind: 'singleton' as const, allowsPerEntity: true },
  entityKeys: { detail: _useGetWatchlistFactory },
  parseInput: (raw: unknown): useGetWatchlistArgs => raw as useGetWatchlistArgs,
  parseResponse: (raw: unknown): GetWatchlistRow => raw as GetWatchlistRow,
  specName: 'useGetWatchlist' as const,
  polling: { hasNats: false } as const,
  viewerSensitive: true as const,
  nonpersistent: true as const,
  viewerRelationship: {"kind":"watchlist","collection":{"listField":"pubkeys","complete":true,"indexArg":"kind"}} as const,
} as unknown as HookSpec<JsonSerialisableArgs, GetWatchlistRow>;
